import { render, staticRenderFns } from "./fee-history.vue?vue&type=template&id=164a3850&scoped=true&"
import script from "./fee-history.vue?vue&type=script&lang=js&"
export * from "./fee-history.vue?vue&type=script&lang=js&"
import style0 from "./fee-history.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164a3850",
  null
  
)

export default component.exports